class CegoXMPPUserSettings {

    constructor(CegoXMPP) {
        this.CegoXMPP = CegoXMPP;
        this.chatWrapper = 'body';
        this.STORAGE_PREFIX = 'chatSettings';
        this.defaultSettings = {
            presenceFriends: {
                type: 'radio',
                value:
                    true
            }
            ,
            presenceAll: {
                type: 'radio',
                value:
                    false
            }
            ,
            friendsMsgBold: {
                type: 'radio',
                value:
                    false
            }
            ,
            highlightMyName: {
                type: 'radio',
                value:
                    true
            }
            ,
            showSmileys: {
                type: 'radio',
                value:
                    true
            }
            ,
            showAccomplishments: {
                type: 'radio',
                value:
                    true
            }
            ,
            showAnimations: {
                type: 'radio',
                value:
                    true
            }
            ,
            showRank: {
                type: 'radio',
                value:
                    false
            }
            ,
            showRankMessages: {
                type: 'radio',
                value:
                    true
            }
            ,
            showChatIcon: {
                type: 'radio',
                value:
                    true,
                action:

                    function (val) {
                        if (val === true) {
                            jQuery('.chat .view .userIcon', this.chatWrapper).show();
                            jQuery('.chat .view', this.chatWrapper).addClass('setMsgMarginLeft');
                        } else {
                            jQuery('.chat .view .userIcon', this.chatWrapper).hide();
                            jQuery('.chat .view', this.chatWrapper).removeClass('setMsgMarginLeft');
                        }
                    }.bind(this)
            }
            ,
            showSendButton: {
                type: 'radio',
                value:
                    false,
                action:

                    function (val) {
                        if (val === true) {
                            jQuery('.sendButton', this.chatWrapper).show();
                            jQuery('.chatInput', this.chatWrapper).addClass('inputWithSendButton');
                        } else {
                            jQuery('.sendButton', this.chatWrapper).hide();
                            jQuery('.chatInput', this.chatWrapper).removeClass('inputWithSendButton');
                        }
                    }.bind(this)
            }
            ,
            myChatIcon: {
                type: 'none'
            }
            ,
            // largeInputField: {
            // 	type: 'radio',
            // 	value: true,
            // 	action: function(val) {
            // 		if (val === true) {
            // 			jQuery('input.chatText', this.chatWrapper).hide();
            // 			jQuery('textarea.chatText', this.chatWrapper).show();
            // 			jQuery('.sendButton', this.chatWrapper).addClass('big');
            // 			jQuery('.chat .viewWrapper', this.chatWrapper).addClass('big');
            // 			jQuery('.directChat .viewWrapper', this.chatWrapper).addClass('big');
            // 		} else {
            // 			jQuery('input.chatText', this.chatWrapper).show();
            // 			jQuery('textarea.chatText', this.chatWrapper).hide();
            // 			jQuery('.sendButton', this.chatWrapper).removeClass('big');
            // 			jQuery('.chat .viewWrapper', this.chatWrapper).removeClass('big');
            // 			jQuery('.directChat .viewWrapper', this.chatWrapper).removeClass('big');
            // 		}
            // 	}
            // },
            boldText: {
                type: 'radio',
                value:
                    false,
                action:

                    function (val) {
                        if (val === true) {
                            jQuery('.pane:not(.userProfile) .view', this.chatWrapper).addClass('setBold');
                        } else {
                            jQuery('.pane:not(.userProfile) .view', this.chatWrapper).removeClass('setBold');
                        }
                    }.bind(this)
            }
            ,
            showDarkBackground: {
                type: 'radio',
                value:
                    false,
                action:

                    function (val) {
                        if (val === true) {
                            jQuery(this.chatWrapper).addClass('darkBackground');
                            jQuery('.pane', this.chatWrapper).addClass('darkBackground');
                            jQuery('.nav', this.chatWrapper).addClass('darkBackground');
                        } else {
                            jQuery(this.chatWrapper).removeClass('darkBackground');
                            jQuery('.pane', this.chatWrapper).removeClass('darkBackground');
                            jQuery('.nav', this.chatWrapper).removeClass('darkBackground');
                        }
                    }.bind(this)
            }
            ,
            textFontSize: {
                type: 'select',
                value:
                    'normal',
                action:
                    function (val) {
                        $(".chatBox").removeClass(["small", "normal", "large"]).addClass(val);
                    }
            }
            ,
            playSounds: {
                type: 'radio',
                value:
                    true
            }
        };

        this.FILTERS = {
            standard: [
                'presenceFriends',
                'presenceAll',
                // 'friendsMsgBold',
                'highlightMyName',
                'showSmileys',
                'showAccomplishments',
                'showAnimations',
                'showRank',
                'showRankMessages',
                // 'showChatIcon',
                'showSendButton',
                // 'boldText',
                //'showDarkBackground',
                'textFontSize',
                // 'myChatIcon',
                // 'playSounds'
            ],
            light:
                [
                    'highlightMyName',
                    'showSmileys',
                    'showAnimations',
                    // 'boldText',
                    // 'showDarkBackground',
                    // 'textFontSize',
                    'onlyShowBigJackpots',
                    'smallJackpotsMarquee',
                    // 'playSounds'
                ]
        };

        this.FILTER = [];

        this.settings = {}
    }

    get(setting) {
        if (this.settings[setting] !== undefined) {
            return this.settings[setting].value;
        } else {
            return undefined;
        }
    }

    load() {
        if (this.FILTER.length === 0) {
            this.setFilter('standard');
        }

        this.STORAGE_PREFIX = app.config.user.id + ':chatSettings';
        this.buildSettings(true);

        this.init();
    }

    buildSettings(load) {
        this.settings = $.extend(true, {}, this.defaultSettings);
        const chatBox = $(".chatBox");
        if (load === true) {
            let tmpSettings = app.storage.get(this.STORAGE_PREFIX);
            if (tmpSettings) {
                $.extend(true, this.settings, JSON.parse(tmpSettings));
            }
        }

        for (let prop in this.settings) {
            if (this.FILTER.length > 0) {
                if ($.inArray(prop, this.FILTER) < 0) {
                    delete this.settings[prop];
                    continue;
                }
                if (this.settings[prop].value) {
                    chatBox.addClass(prop);
                }
            }
        }
    }

    save() {
        app.storage.set(this.STORAGE_PREFIX, JSON.stringify(this.settings));
    }

    assign() {
        let type, value;
        for (let prop in this.settings) {
            jQuery('#' + prop).parents('li').css('display', 'block');
            type = this.settings[prop].type;
            value = this.settings[prop].value;
            if (type === 'radio') {
                this.setCheckboxState(prop, value);
            } else if (type === 'select') {
                jQuery('#' + prop + ' option[value=' + value + ']').prop('selected', true);
            }

            if (typeof this.settings[prop].action === 'function') {
                this.settings[prop].action(value);
            }
        }
    }

    setFilter(filter) {
        this.FILTER = this.FILTERS[filter];
    }

    init() {
        this.assign();
        this.bind();
    }

    bind() {
        let id, setting;
        const that = this;
        jQuery('.settings li', this.chatWrapper).on('click', function () {
            if (jQuery('.radio', this).length > 0) {
                setting = jQuery('.radio', this).attr('data-value');
                let newSetting = (setting === 'true') ? false : true;
                id = jQuery('.radio', this).attr('id');
                that.settings[id].value = newSetting;
                that.setCheckboxState(id, newSetting);
                that.save();
                if (typeof that.settings[id].action === 'function') {
                    that.settings[id].action(newSetting);
                }
            }
        });

        jQuery('.settings select', this.chatWrapper).on('change', function () {
            setting = jQuery(this).val();
            id = jQuery(this).attr('id');
            that.settings[id].value = setting;
            that.save();

            if (typeof that.settings[id].action === 'function') {
                that.settings[id].action(setting);
            }
        });

        jQuery('.settings .resetSettings', this.chatWrapper).on('click', function () {
            this.buildSettings();
            this.save();
            this.assign();
        }.bind(this));

        jQuery('.settings .deleteHistory', this.chatWrapper).on('click', function () {
            app.storage.clean();
        }.bind(this));
    }

    setCheckboxState(id, value) {
        let radio = jQuery('#' + id);
        let state = (value === true) ? 'fa-check-square' : 'fa-square';
        radio.attr('data-value', value);
        radio.removeClass('fas fa-square fa-check-square');
        radio.addClass('fa');
        radio.addClass(state);
    }
}
